import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register the PWA service worker in production only (OMN-344). Skipped in dev
// so it never interferes with the CRA hot-reload / error overlay.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  // When a new service worker takes control (after a deploy), reload once so the
  // installed PWA picks up the new build instead of staying on the cached one.
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        // Re-check for a newer version whenever the app regains focus (e.g. the
        // user reopens the installed PWA) so updates land without a manual clear.
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') registration.update();
        });
      })
      .catch(() => {
        /* PWA is a progressive enhancement — ignore registration failures */
      });
  });
}
